import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { spacing2x } from '../../styles/spacing.js';
import { getAdornment } from '../../utils/adornment.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["endAdornment", "hideLabel", "iconSize", "label", "startAdornment"];
var Label = styled.span.withConfig({
  displayName: "A11YLabel__Label",
  componentId: "sc-1lm9tqw-0"
})(function (props) {
  return {
    marginInlineStart: props.pushStart ? spacing2x : void 0,
    marginInlineEnd: props.pushEnd ? spacing2x : void 0,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});
var LabelWrapper = styled.span.withConfig({
  displayName: "A11YLabel__LabelWrapper",
  componentId: "sc-1lm9tqw-1"
})(["&&{align-items:center;display:inline-flex;flex:1;justify-content:space-between;max-width:100%;overflow:hidden;vertical-align:bottom;text-decoration:inherit;}"]);
var A11YLabel = /*#__PURE__*/React.memo(function (_ref) {
  var endAdornment = _ref.endAdornment,
    hideLabel = _ref.hideLabel,
    _ref$iconSize = _ref.iconSize,
    size = _ref$iconSize === void 0 ? 16 : _ref$iconSize,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    startAdornment = _ref.startAdornment,
    rest = _objectWithoutProperties(_ref, _excluded);
  var startAddon = getAdornment(startAdornment, {
    size: size
  });
  var endAddon = getAdornment(endAdornment, {
    size: size
  });
  var labelText = label.charAt(0).toUpperCase() + label.slice(1);
  return /*#__PURE__*/jsxs(LabelWrapper, _objectSpread(_objectSpread({}, rest), {}, {
    children: [startAddon, hideLabel ? /*#__PURE__*/jsx(VisuallyHidden, {
      children: labelText
    }) : /*#__PURE__*/jsx(Label, {
      pushStart: !!startAddon,
      pushEnd: !!endAddon,
      children: labelText
    }), endAddon]
  }));
});
A11YLabel.displayName = "A11YLabel";

export { A11YLabel, Label, LabelWrapper };
